export default __webpack_public_path__ + "media/components/GlobalSearch/images/support-article-daff361558e63c79354edffba2e97d02.png";